import getBulkheadPithagores from "./getBulkheadPithagores";

export default (width: number, height: number) => {
  const diag = getBulkheadPithagores(width, height);
  const diagAngle = Math.asin(height / diag);
  return { diag, diagAngle };
};
